import React from "react";
import { Link } from "react-router-dom";

const IndustryCompliance: React.FC = () => {
  const complianceItems = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2v1" />
          <path d="M12 21v1" />
          <path d="m4.93 4.93 .71.71" />
          <path d="m18.36 18.36 .71.71" />
          <path d="M2 12h1" />
          <path d="M21 12h1" />
          <path d="m4.93 19.07 .71-.71" />
          <path d="m18.36 5.64 .71-.71" />
        </svg>
      ),
      title: "C2PA Compliant",
      description: "Coalition for Content Provenance and Authenticity (C2PA) certified systems ensure full transparency"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 12l2 2 4-4" />
          <path d="M21 12c-1.1 4.9-4.7 8.6-9.5 9.5A9.5 9.5 0 0 1 3 12c1.1-4.9 4.7-8.6 9.5-9.5A9.5 9.5 0 0 1 21 12z" />
        </svg>
      ),
      title: "DDEX & W3C Standards",
      description: "Employs the industry standards using DDEX for studio provenance and W3C standards"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
          <line x1="9" x2="9" y1="9" y2="15" />
          <line x1="15" x2="15" y1="9" y2="15" />
        </svg>
      ),
      title: "EU AI Act Copyright Directive",
      description: "Adheres to the latest Artical directive on AI and the DSM directive requirements"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27,6.96 12,12.01 20.73,6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      ),
      title: "ISO Metadata Standards",
      description: "Uses standard industry identifiers like ISRCs, ISNI alongside timestamps and creator's signed provenance"
    }
  ];

  return (
    <div className="py-16 bg-gray-800 text-white">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="text-center mb-12 max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white via-tagblue to-white mb-4 leading-relaxed py-2">
            Industry Compliance
          </h2>
          <p className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto">
            The Copyrightability Engine ensures your music meets all current and emerging regulatory requirements
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {complianceItems.map((item, index) => (
            <div key={index} className="text-center">
              <div className="text-tagblue mb-4 flex justify-center">
                {item.icon}
              </div>
              <h3 className="text-lg md:text-xl font-semibold mb-3">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="bg-tagblue text-white px-8 py-4 rounded-lg inline-block">
            <span className="text-lg font-semibold">Get ahead of regulatory requirements with comprehensive legal compliance</span>
            <Link 
              to="/join-waitlist"
              className="ml-4 bg-white text-tagblue px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors inline-block"
            >
              Join the Waitlist
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustryCompliance;